import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/interfaces/user';
import { AlertController } from '@ionic/angular';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-users',
  templateUrl: './users.page.html',
  styleUrls: ['./users.page.scss'],
})
export class UsersPage implements OnInit {
  selectedView = 'main';
  editFields = false;
  editedId: string;

  firstNameField: string;
  lastNameField: string;
  emailField: string;
  usernameField: string;
  passwordField: string;
  dniField: string;
  roleField: string;
  colorField: number;

  columns = [
    {
      field: 'firstName',
      name: 'nombre',
      width: 20
    },
    {
      field: 'lastName',
      name: 'apellido',
      width: 20
    },
    {
      field: 'dni',
      name: 'DNI',
      width: 20
    },
    {
      field: 'username',
      name: 'Nombre usuario',
      width: 15
    },
    {
      field: 'role',
      name: 'Role',
      width: 15
    },
    {
      field: 'action',
      name: 'acciones rápidas',
      width: 10,
      actions: [
        {
          type: 'delete'
        },
        {
          type: 'edit'
        }
      ]
    }
  ];

  lines: User[];
  filteredLines: User[];
  usersForm: FormGroup;

  constructor(private alert: AlertController,
    private rest: RestService,
    private utils: UtilsService
  ) {
    this.usersForm = new FormGroup({
      nombre: new FormControl('', [Validators.required]),
      apellido: new FormControl('', [Validators.required]),
      dni: new FormControl('', [Validators.required]),
      nombreUsuario: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      contraseña: new FormControl('', [Validators.required], null),
      role: new FormControl('', [Validators.required]),
      color: new FormControl(null, null)
    });
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.getUsers();
  }

  changeView(view: string) {
    this.selectedView = view;
    this.editFields = false;
    // this.usersForm = new FormGroup({
    //   nombre: new FormControl('', [Validators.required]),
    //   apellido: new FormControl('', [Validators.required]),
    //   dni: new FormControl('', [Validators.required]),
    //   nombreUsuario: new FormControl('', [Validators.required]),
    //   email: new FormControl('', [Validators.required]),
    //   contraseña: new FormControl('', [Validators.required], null),
    //   role: new FormControl('', [Validators.required]),
    // });
  }

  addNew() {
    this.selectedView = 'editMode';
    this.clearData();
    this.editFields = false;
    console.log('addnew');
  }

  async getUsers() {
    await this.utils.showLoading();
    const result: any = await this.rest.getUsers(1, 1000);
    this.lines = result.body.records;
    console.log(this.lines);

    for (let i = 0; i < this.lines.length; i++) {
      if (this.lines[i].role === 'fake') {
        console.log(this.lines[i]);
        this.lines.splice(i, 1)
      }
    };
    this.filteredLines = this.lines;
    await this.utils.hideLoading();
  }

  async saveItem() {
    if (this.roleField === 'repartidor' && !this.colorField) {
      this.colorField = 1;
    }
    const sendUser: User = {
      firstName: this.firstNameField,
      lastName: this.lastNameField,
      email: this.emailField,
      username: this.usernameField,
      password: this.passwordField,
      dni: this.dniField,
      role: this.roleField,
      color: this.colorField
    };

    await this.utils.showLoading();
    const result = await this.rest.createUser(sendUser);
    console.log(result);
    if (result) {
      this.clearData();
      this.selectedView = 'main';
      this.getUsers();
    }
    await this.utils.hideLoading();
  }

  async editItem() {
    if (this.roleField === 'repartidor' && !this.colorField) {
      this.colorField = 1;
    }
    const sendUser: User = {
      _id: this.editedId,
      firstName: this.firstNameField,
      lastName: this.lastNameField,
      email: this.emailField,
      username: this.usernameField,
      password: this.passwordField,
      dni: this.dniField,
      role: this.roleField,
      color: this.colorField
    };

    await this.utils.showLoading();
    const result = await this.rest.editUser(sendUser);
    console.log(result);
    if (result) {
      this.selectedView = 'main';
      this.getUsers();
    }
    await this.utils.hideLoading();
  }

  async doAction(data) {
    console.log(data);
    const user: User = data.line;
    if (data.action === 'delete') {
      this.deleteItem(user);
    }
    if (data.action === 'edit') {
      console.log('edit');
      console.log(user.color);
      this.selectedView = 'editMode';
      this.editedId = user._id;
      this.firstNameField = user.firstName;
      this.lastNameField = user.lastName;
      this.emailField = user.email;
      this.usernameField = user.username;
      this.passwordField = user.password;
      this.dniField = user.dni;
      this.roleField = user.role;
      this.colorField = user.color;
      console.log(this.colorField);
      this.editFields = true;

      this.usersForm = new FormGroup({
        nombre: new FormControl('', [Validators.required]),
        apellido: new FormControl('', [Validators.required]),
        dni: new FormControl('', [Validators.required]),
        nombreUsuario: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required]),
        contraseña: new FormControl('', null),
        role: new FormControl('', [Validators.required]),
        color: new FormControl('')
      });
    }
  }

  async deleteItem(user: User) {
    const alert = await this.alert.create({
      header: '¿Borrar?',
      message: 'Borrar usuario ' + user.firstName,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            console.log('Item to remove!!!');
            await this.utils.showLoading();
            await this.rest.deleteUser(user._id);
            this.getUsers();
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }

  clearData() {
    this.firstNameField = '';
    this.lastNameField = '';
    this.emailField = '';
    this.usernameField = '';
    this.passwordField = '';
    this.dniField = '';
    this.roleField = '';
    this.colorField = null;
  }

  search(event: any) {
    this.filteredLines = this.lines;
    var filter = event.target.value;
    // Contains:
    var users = this.lines.map(user => user.username);
    users = users.filter(n => n.toLowerCase().includes(filter.toLowerCase()));
    this.filteredLines = this.filteredLines.filter(user => users.includes(user.username));
    // Starts with:
    // this.filteredLines = this.filteredLines.filter(user => user.username.toLowerCase().startsWith(filter));
  }
}
